import Swiper from 'swiper';
import { Navigation, Keyboard } from 'swiper/modules';
import { onDomReady } from '../../JavaScript/on-dom-ready';

onDomReady(() => {
  for (const slider of document.getElementsByClassName('slider--news')) {
    const swiperElement = slider.querySelector('.swiper');
    if (!(swiperElement instanceof HTMLElement)) {
      continue;
    }

    new Swiper(swiperElement, {
      modules: [Navigation, Keyboard],
      spaceBetween: 16,
      breakpoints: {
        320: {
          slidesPerView: 1.5,
        },
        480: {
          slidesPerView: 2.25,
        },
        620: {
          slidesPerView: 3.25,
        },
        1200: {
          slidesPerView: 4,
        },
      },
      navigation: {
        nextEl: slider.querySelector<HTMLElement>('.swiper-button-next'),
        prevEl: slider.querySelector<HTMLElement>('.swiper-button-prev'),
        addIcons: false,
      },
    });
  }
});
